import { type FC } from 'react'

import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { DeviceVariantColorOption } from 'modules/it_management/components/device_catalog/DeviceVariantSelector/types'

export interface DeviceVariantColorProps {
  variant: DeviceVariantColorOption
  value?: string
  onChange: (value: string) => void
}

export const DeviceVariantColor: FC<DeviceVariantColorProps> = ({ variant, value, onChange }) => {
  return (
    <div className="flex flex-col">
      <SectionHeader title={variant.title} description={''} />
      <div className="flex flex-row gap-2">
        {variant.variants.map((option) => {
          const isSelected = option.id === value

          return (
            <div
              className="flex flex-row items-center justify-center flex-none rounded-full"
              style={{
                width: '40px',
                height: '40px',
                border: `2px solid ${isSelected ? 'var(--color-group1)' : 'transparent'}`,
              }}
            >
              <div
                className="cursor-pointer flex-none rounded-full"
                style={{
                  width: '32px',
                  height: '32px',
                  backgroundColor: option.color,
                }}
                onClick={() => onChange(option.id)}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
